import React from 'react';
import {Message} from "primereact/message";
import {STEP_CATALOG} from "./onboardingConfig";
import ProductsOnboardingStep from "./ProductsOnboardingStep";
import MarketplaceIntegrationStep from "./MarketplaceIntegrationStep";
import MarketplaceProductsStep from "./MarketplaceProductsStep";
import MarketplacePriceCheckStep from "./MarketplacePriceCheckStep";
import SitesOnboardingStep from "./SitesOnboardingStep";
import SearchOnboardingStep from "./SearchOnboardingStep";
import MatchOnboardingStep from "./MatchOnboardingStep";
import SettingsOnboardingStep from "./SettingsOnboardingStep";
import ScheduledJobsOnboardingStep from "./ScheduledJobsOnboardingStep";
import PriceCheckOnboardingStep from "./PriceCheckOnboardingStep";
import PricingOnboardingStep from "./PricingOnboardingStep";
import MapOnboardingStep from "./MapOnboardingStep";
import RequestProbes from "../Admin/RequestProbes";
import Overview from "../Dashboard/Overview";

// Placeholder content for each onboarding step. The real UI for each step is
// implemented in later phases — this skeleton renders the frame, the step's
// purpose, and a "coming soon" notice so the wizard + monitor work end-to-end.
const PlaceholderStep = ({stepKey, t, summary}) => {
    const def = STEP_CATALOG[stepKey];
    if (!def) return null;

    return (
        <div>
            <h2 style={{marginTop: 0, display: 'flex', alignItems: 'center', gap: 10}}>
                <i className={def.icon}/> {t(def.labelKey, def.labelDefault)}
            </h2>
            <p style={{color: '#6b7280', maxWidth: 640}}>{t(def.descKey, def.descDefault)}</p>

            <div style={{marginTop: 20}}>
                <Message severity="info"
                         text={t('onboarding.placeholder', 'Bu adımın arayüzü sonraki fazda eklenecek. İskelet, akış ve canlı izleme şu an çalışıyor.')}/>
            </div>

            {/* Lightweight live summary so even the placeholder reflects real data. */}
            {summary && Object.keys(summary).length > 0 && (
                <pre style={{marginTop: 18, background: '#f9fafb', border: '1px solid #eee', borderRadius: 8, padding: 12,
                    fontSize: '0.8rem', maxWidth: 640, overflowX: 'auto'}}>
                    {JSON.stringify(summary, null, 2)}
                </pre>
            )}
        </div>
    );
};

const OnboardingStepContent = ({stepKey, t, status, refresh, onOpenSiteDefinition, focusWebsite, campaignId}) => {
    if (stepKey === 'settings')
        return <SettingsOnboardingStep t={t} status={status} refresh={refresh}/>;
    if (stepKey === 'scheduled_jobs')
        return <ScheduledJobsOnboardingStep t={t} status={status} refresh={refresh}/>;
    if (stepKey === 'price_check')
        return <PriceCheckOnboardingStep t={t} status={status} refresh={refresh}/>;
    if (stepKey === 'products')
        return <ProductsOnboardingStep t={t} status={status} refresh={refresh}/>;
    if (stepKey === 'integration')
        return <MarketplaceIntegrationStep t={t} campaignId={campaignId}/>;
    if (stepKey === 'marketplace_products')
        return <MarketplaceProductsStep t={t} campaignId={campaignId}/>;
    if (stepKey === 'marketplace_price_check')
        return <MarketplacePriceCheckStep t={t} campaignId={campaignId}/>;
    if (stepKey === 'sites')
        return <SitesOnboardingStep t={t} status={status} refresh={refresh} onOpenSiteDefinition={onOpenSiteDefinition}/>;
    if (stepKey === 'search')
        return <SearchOnboardingStep t={t} status={status} refresh={refresh}/>;
    if (stepKey === 'match')
        return <MatchOnboardingStep t={t} status={status} refresh={refresh}/>;
    if (stepKey === 'pricing')
        return <PricingOnboardingStep t={t} status={status} refresh={refresh}/>;
    if (stepKey === 'map')
        return <MapOnboardingStep t={t} status={status} refresh={refresh}/>;
    if (stepKey === 'ready')
        return (
            <div>
                <h2 style={{marginTop: 0, display: 'flex', alignItems: 'center', gap: 10}}>
                    <i className="pi pi-chart-bar"/> {t('onboarding.step.ready.label', 'Genel Bakış')}
                </h2>
                <Overview/>
            </div>
        );
    if (stepKey === 'prepare')
        return (
            <div>
                <h2 style={{marginTop: 0, display: 'flex', alignItems: 'center', gap: 10}}>
                    <i className="pi pi-cog"/> {t('onboarding.step.prepare.label', 'Site Tanımlama')}
                </h2>
                <RequestProbes initialWebsite={focusWebsite} campaignId={campaignId} embedded={true}/>
            </div>
        );

    const step = (status?.steps || []).find(s => s.key === stepKey);
    return <PlaceholderStep stepKey={stepKey} t={t} summary={step?.summary}/>;
};

export default OnboardingStepContent;
